<template>
    <div>
        <text-input
            name="name"
            label="Namn"
            :required="true"
            :autofocus="true"
            :value="contact.name"
        />
        <text-input
            name="role"
            label="Etikett/roll"
            :required="false"
            :value="contact.role"
        />
        <text-input
            name="phone"
            label="Telefon"
            :required="false"
            :value="contact.phone"
        />
        <text-input
            name="email"
            label="E-post"
            :required="false"
            :value="contact.email"
        />
    </div>
</template>
<script>
    export default {
        props: {
            contact: {
                required: false,
                type: Object,
                default: () => {
                    return {
                        name: '',
                        role: '',
                        phone: '',
                        email: '',
                    };
                },
            },
        },
    };
</script>
